import { type LogTimelineEntry, serializeError } from './logTimeline';

const UNCAUGHT_ERROR_BUFFER_SIZE = 100;

let entries: LogTimelineEntry[] = [];
let installed = false;

function record(entry: LogTimelineEntry): void {
  entries.push(entry);
  if (entries.length > UNCAUGHT_ERROR_BUFFER_SIZE) {
    entries = entries.slice(-UNCAUGHT_ERROR_BUFFER_SIZE);
  }
}

function describeRejectionReason(reason: unknown): string {
  if (reason == null) {
    return 'Unhandled promise rejection';
  }
  if (
    typeof reason === 'object' &&
    'message' in reason &&
    typeof (reason as { message?: unknown }).message === 'string'
  ) {
    return (reason as { message: string }).message;
  }
  return String(reason);
}

export function installGlobalErrorListeners(): void {
  if (installed || typeof window === 'undefined') {
    return;
  }
  installed = true;

  window.addEventListener('error', event => {
    try {
      record({
        at: new Date().toISOString(),
        source: 'window.onerror',
        level: 'error',
        message: event.message || 'Uncaught error',
        error: serializeError(event.error),
      });
    } catch {
      /* capture must never break the page */
    }
  });

  window.addEventListener('unhandledrejection', event => {
    try {
      const { reason } = event as PromiseRejectionEvent;
      record({
        at: new Date().toISOString(),
        source: 'unhandledrejection',
        level: 'error',
        message: describeRejectionReason(reason),
        error: serializeError(reason),
      });
    } catch {
      /* never throw */
    }
  });
}

export function getUncaughtErrorEntries(): LogTimelineEntry[] {
  return entries.slice();
}

export function __resetErrorCaptureForTesting(): void {
  entries = [];
}
